// Actions
export const setDashboard = ({ commit }, payload) => {
  commit('SET_DASHBOARD', payload)
}
export const addDashboard = ({ commit }, payload) => {
  commit('ADD_DASHBOARD', payload)
}
export const setDashboardLoading = ({ commit }, payload) => {
  commit('SET_DASHBOARD_LOADING', payload)
}

export const setPermissions = ({ commit }, payload) => {
  commit('SET_PERMISSIONS', payload)
}
export const addPermissions = ({ commit }, payload) => {
  commit('ADD_PERMISSIONS', payload)
}
export const setPermissionsLoading = ({ commit }, payload) => {
  commit('SET_PERMISSIONS_LOADING', payload)
}

export const setUpdateDash = ({ commit }, payload) => {
  commit('SET_UPDATE_DASH', payload)
}
export const addUpdateDash = ({ commit }, payload) => {
  commit('ADD_UPDATE_DASH', payload)
}
export const setUpdateDashLoading = ({ commit }, payload) => {
  commit('SET_UPDATE_DASH_LOADING', payload)
}

export const setEmbed = ({ commit }, payload) => {
  commit('SET_EMBED', payload)
}
export const addEmbed = ({ commit }, payload) => {
  commit('ADD_EMBED', payload)
}
export const setEmbedLoading = ({ commit }, payload) => {
  commit('SET_EMBED_LOADING', payload)
}

export const setCache = ({ commit }, payload) => {
  commit('SET_CACHE', payload)
}

export const addCache = ({ commit }, payload) => {
  commit('ADD_CACHE', payload)
}
export const setCacheLoading = ({ commit }, payload) => {
  commit('SET_CACHE_LOADING', payload)
}

export const setStatusCache = ({ commit }, payload) => {
  commit('SET_STATUS_CACHE', payload)
}
